import { ButtonBase } from '@mui/material'
import styled from 'styled-components'

export const FloaterContainer = styled.div`
  position: fixed;
  right: 20px;
  bottom: 24px;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;

  @media (min-width: 768px) {
    right: 24px;
    bottom: 32px;
  }
`

export const FloaterExpandButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #5f2ec7 0%, #7c3aed 100%);
  color: white;
  border: none;
  border-radius: 28px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 4px 14px rgba(95, 46, 199, 0.4);
  transition: all 0.2s ease;
  min-width: 56px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(95, 46, 199, 0.45);
  }

  &:active {
    transform: translateY(0);
  }
`

export const FloaterExpandButtonInner = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const FloaterCard = styled.div`
  width: 280px;
  background: ${({ themeType }) => (themeType === 'dark' ? '#2d2d35' : '#ffffff')};
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
  animation: slideIn 0.25s ease-out;
  border: 1px solid ${({ themeType }) => (themeType === 'dark' ? '#3d3d47' : '#e8e8ec')};

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`

export const FloaterHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: linear-gradient(135deg, #5f2ec7 0%, #7c3aed 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
`

export const FloaterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 16px;
`

export const SuccessManagerAvatar = styled.img`
  border-radius: 50%;
  width: 56px;
  height: 56px;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 10px;
`

export const YourSuccessManagerText = styled.span`
  color: #ff5530;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
`

export const SideProfileName = styled.span`
  color: #080eaa;
  font-size: 16px;
  font-weight: 700;
`

export const SuccessManagerDetailsContainer = styled.div`
  border-radius: 12px;
  background: #d7dbff;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 16px;
`

export const NoSuccessManagerHeading = styled.div`
  color: #715ed3;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
`

export const NoSuccessManagerButton = styled(ButtonBase)`
  && {
    border-radius: 14px;
    background: linear-gradient(149deg, #6977df 0%, #ca98ff 100%);
    width: 100%;
    padding: 12px 20px;
    font-size: 16px;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    transition: background-position 0.3s ease-out;

    &:hover {
      background-position: -200px;
    }
  }
`

export const NoSuccessManagerSubext = styled.span`
  font-size: 14px;
  display: block;
`
